///////COMPONENTS///////
import { put, select, takeLatest } from 'redux-saga/effects'
import ActionsTypes from '../../constants/ActionsTypes'
import { globalLoadingActionCreators, errorManagerActionCreators, logExtranetActionCreators } from '../actions'
import * as R from '../../constants/Endpoint'
import { API_TOKEN } from '../../config/AxiosConfig'
import { selectIdsUser } from '../selectors/user'

const postLogExtranet = function* ({ payload }) {
	const bodyMsg = payload.filters
	const user = yield select(selectIdsUser)
	const apiCall = R.POST_LOG_EXTRANET(payload.queryParams)
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).post(apiCall, bodyMsg)

		yield put(logExtranetActionCreators.postLogExtranetSuccess(data.data))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(logExtranetActionCreators.postLogExtranetFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const sagas = function* () {
	yield takeLatest(ActionsTypes.POST_LOG_EXTRANET, postLogExtranet)
}

export default sagas
